"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _core = require("@material-ui/core");
var useStyles = (0, _core.makeStyles)({
  paper: {
    width: '600px'
  },
  header: {
    borderBottom: '1px solid rgba(112, 112, 112, 0.1)',
    padding: '116px 48px 17.5px 48px',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    position: 'relative'
  },
  close: {
    display: 'inline-block',
    border: '0',
    backgroundColor: 'transparent',
    margin: '88px 24px 0',
    position: 'absolute',
    right: '0px',
    top: '0px',
    outline: '0',
    '&:hover': {
      cursor: 'pointer'
    },
    '& > svg': {
      color: '#C3C3C3',
      width: '22px !important',
      height: '22px'
    }
  },
  body: function body(_ref) {
    var noPadding = _ref.noPadding;
    return {
      padding: noPadding ? '0' : '45px 0',
      height: '100%',
      '& > div > *:not(.divider)': {
        padding: '0 48px'
      },
      '& > div > .noPadding': {
        padding: '0'
      }
    };
  },
  status: {
    marginTop: '20px'
  },
  footer: {
    height: '150px',
    borderTop: '1px solid rgb(112, 112, 112, 0.1)',
    padding: '0px 53px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  subtitle: {
    '& > h4': {
      margin: '3px 0 0 0',
      fontSize: '11px',
      color: 'rgba(52, 52, 52, 0.5)'
    }
  },
  stats: {
    margin: '40px 0 0 0',
    display: 'flex',
    position: 'relative',
    '& > div > p:nth-of-type(2)': {
      fontSize: '18px',
      '& > span > img': {
        marginRight: '8px'
      }
    },
    '& > div:not(:first-child):not(:nth-last-child(2))': {
      marginRight: '34px'
    },
    '& > svg': {
      fontSize: '14px',
      position: 'absolute',
      right: 0,
      transform: 'translateY(-50%)',
      top: '50%'
    }
  }
});
exports.useStyles = useStyles;